import React, { Component } from "react";
import moment from "moment";
import RenderField from "../RenderField/RenderField";

import "./DateRangeFilter.scss";

const toInputValue = (date) => (date ? moment(date).format("YYYY-MM-DD") : "");
const fromInputValue = (value) => (value ? moment(value, "YYYY-MM-DD").toDate() : null);

class DateRangeFilter extends Component {
    handleFromChange = (event) => {
        const { toDate, onApply } = this.props;
        const next = fromInputValue(event.target.value);
        if (onApply) onApply({ fromDate: next, toDate });
    };

    handleToChange = (event) => {
        const { fromDate, onApply } = this.props;
        const next = fromInputValue(event.target.value);
        if (onApply) onApply({ fromDate, toDate: next });
    };

    handleClear = () => {
        const { onClear } = this.props;
        if (onClear) onClear();
    };

    render() {
        const { fromDate, toDate } = this.props;
        const hasValue = !!fromDate || !!toDate;

        return (
            <div className="date_range_filter">
                <div className="date_range_field">
                    <span className="date_range_label">с</span>
                    <RenderField
                        id="date_range_from"
                        type="date"
                        name="date_range_from"
                        placement="start"
                        meta={{}}
                        input={{
                            value: toInputValue(fromDate),
                            onChange: this.handleFromChange,
                            size: "small",
                        }}
                    />
                </div>
                <div className="date_range_field">
                    <span className="date_range_label">по</span>
                    <RenderField
                        id="date_range_to"
                        type="date"
                        name="date_range_to"
                        placement="start"
                        meta={{}}
                        input={{
                            value: toInputValue(toDate),
                            onChange: this.handleToChange,
                            size: "small",
                        }}
                    />
                </div>
                {hasValue && (
                    <button
                        type="button"
                        className="date_range_clear"
                        onClick={this.handleClear}
                        aria-label="Сбросить период"
                    >
                        ×
                    </button>
                )}
            </div>
        );
    }
}

export default DateRangeFilter;
